import styled, { css } from 'styled-components';

export const Row = styled.div<{ $unread: boolean }>`
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  transition: background-color 150ms ease;

  ${({ theme: { colors } }) => css`
    border-bottom: 1px solid ${colors.outlineVariant};
  `}

  ${({ $unread, theme: { colors } }) =>
    $unread &&
    css`
      background-color: ${colors.surfaceContainerHighest ?? colors.surfaceContainer};
    `}

  &:hover {
    ${({ theme: { colors } }) => css`
      background-color: ${colors.surfaceContainerHighest ?? colors.surfaceContainer};
    `}
  }

  &:hover button[data-role='delete-notification'],
  &:focus-within button[data-role='delete-notification'] {
    opacity: 1;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ContentButton = styled.button`
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  text-align: left;
  cursor: pointer;
  border: none;
  background: none;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level3} ${spacing.level4};
    gap: ${spacing.level3};
  `}

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors } }) => colors.primary};
    outline-offset: -2px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 150ms ease,
    background-color 150ms ease;

  ${({ theme: { colors } }) => css`
    background-color: transparent;
    color: ${colors.onSurfaceVariant};

    &:hover {
      background-color: ${colors.surfaceContainerHigh ?? colors.surfaceContainer};
      color: ${colors.onSurface};
    }

    &:focus-visible {
      opacity: 1;
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}

  & > svg {
    width: 18px;
    height: 18px;
  }
`;

export const UnreadDot = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;

  ${({ theme: { colors } }) => css`
    background-color: ${colors.primary};
  `}
`;

export const ReadDotPlaceholder = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: 6px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  padding-right: 32px;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level1};
  `}
`;

export const Title = styled.div<{ $unread: boolean }>`
  font-size: 14px;
  font-weight: ${({ $unread }) => ($unread ? 600 : 500)};
  line-height: 1.3;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurface};
  `}
`;

export const BodyText = styled.div`
  font-size: 13px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};
  `}
`;

export const TimestampText = styled.div`
  font-size: 11px;
  margin-top: 2px;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};
  `}
`;
